import React from 'react'
import Practice from '../Components/Practice_area/Practice'

const PageFive = () =>{
    return (

        <div>
            <Practice/>
        </div>
      )
}

export default PageFive
